import { commentItems } from '@/mocks/darkwebData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            读者评论
          </h2>
          <p className="text-foreground-600 text-sm mt-2">
            来自读者的真实声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-sm shrink-0">
                  {item.avatar}
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-950">{item.author}</div>
                  <div className="text-xs text-foreground-500">{item.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                &ldquo;{item.content}&rdquo;
              </p>
              <div className="text-xs text-accent-600 pt-3 border-t border-background-200/70 flex items-center gap-1">
                <i className="ri-article-line"></i>
                <span className="truncate">{item.article}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}